import React, { Component } from 'react';
import articlesJSON from '../../data/articles.json'
import Article from './Article/Article'
import { Redirect } from 'react-router-dom'
import MediaQuery from 'react-responsive';
import { DFPSlotsProvider, AdSlot } from 'react-dfp';
import globalJSON from 'data/global.json'
import $ from 'jquery';
import IsNotDomestic from 'helpers/IsNotDomestic';
import Header from './Header/Header';
import ExternalArticles from '../App/ExternalArticles/ExternalArticles';
import WorldNews from '../App/WorldNews/WorldNews';

import classes from './Articles.module.scss';
import { Online } from 'react-detect-offline';
const globalImages = require.context('../../images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);



class Articles extends Component {

    constructor(props) {

		super(props);
		this.articlePosition = []
		this.infinateArticles = []
		// Sets up our initial state
		this.state = {
			error: false,
			hasMore: true,
			isLoading: false,
			redirect: false,
			articles: []
		};
	
		//get page url
		let articleNameUrl = props.match.params.articleTitle;

		// check if page url matches same in json 
		this.defaultArticle =  articlesJSON.articles.find( article => article.url === articleNameUrl ? article: '')

		if(this.defaultArticle){
			this.infinateArticles = this.getNextArticles();
			//adding the first articlePosition when scroll
			if ( this.articlePosition.length === 0 ) {
				this.articlePosition.push(
					{ 'id': this.defaultArticle.id,
						'position': document.documentElement.offsetHeight,
						'url': this.defaultArticle.url
					}
				)
			}

			this.state.articles.push(this.defaultArticle);

			//Default position of the scroll
			window.scrollTo(0,0);
			
			// Binds our scroll event handler
			let self = this;

			this.onScroll = this.onScroll.bind(this)
			window.addEventListener("scroll", this.onScroll);

		}
	}
	
	onScroll(){
		//extract variables from this

		var CurrentPosition = this.getCurrentPosition();
		
		if ( CurrentPosition >= (document.documentElement.offsetHeight - document.documentElement.clientHeight) ) {
			this.changeCurrentArticle()
		}

		this.checkForPageUpdate(CurrentPosition)
	}
	
	getNextArticles(){
		let nextArticles = []
		for (var item in this.defaultArticle.similarArticles.ids) {

			let idRef = this.defaultArticle.similarArticles.ids[item];
			nextArticles.push(articlesJSON.articles.find( article => article.id == idRef ));

		}
		return nextArticles;
	}

	componentWillReceiveProps(nextProps){
		

		
		// get page url
		let articleName = nextProps.match.params.articleTitle;

		//get details from url
		let nextArticle = articlesJSON.articles.find( article => article.url === articleName)

		if(nextArticle){
			if(nextArticle.url != this.defaultArticle.url){
				
				this.setState({
					error: false,
					hasMore: true,
					isLoading: false,
					redirect: false,
					articles: []
				});
		
				
		
				this.articlePosition = []
				this.infinateArticles = []

				this.defaultArticle = nextArticle;

				if(this.defaultArticle){
					
					this.infinateArticles = this.getNextArticles();

					if ( this.articlePosition.length === 0 ) {
						this.articlePosition.push(
							{ 'id': this.defaultArticle.id,
								'position': document.documentElement.offsetHeight,
								'url': this.defaultArticle.url
							}
						)
					}

					//change article url	
					window.history.pushState( this.defaultArticle.url, this.defaultArticle.title, this.defaultArticle.url );
					window.scrollTo(0,0);

					// add new article

					this.setState({
						articles: [this.defaultArticle]
					});

				}
			}
		}
  }
	
	componentWillUnmount(){

		window.removeEventListener("scroll", this.onScroll);
		
	}

	componentWillMount() {
		//get page url
		let articleName = this.props.match.params.articleTitle;

		// check if page url matches same in json 
		let articleExist =  articlesJSON.articles.find( article => article.url === articleName ? article: '')
		
		if ( !articleExist )	{
			this.setState({redirect : true});
		}
		
		this.setState({
			articles: [articleExist]
		});
		
	}

	getCurrentPosition = () => {
		return Math.abs( window.innerHeight + ( window.scrollY || document.body.scrollTop || document.documentElement.scrollTop) );
	}



	checkForPageUpdate = (CurrentPosition) => {

		//extract variables from this
		const {
			offset
		} = this;
		let articleElements = document.querySelectorAll(`.${classes.articles}`)
		//adding rest of articles when scrolling
		if( this.articlePosition.length > 1 ){
				
			this.articlePosition.forEach( (e, i)  => {
				
				
				let $element = $('#articles_'+e.id);
				if ( $element.position().top < CurrentPosition && CurrentPosition < $element.position().top + $element.outerHeight(true) ) {
					//check if urls are not matching

					var url = window.location.pathname;
					var getArticleURL = url.substring(url.lastIndexOf('/')+1);
					if ( getArticleURL != e.url){
						//change url
						window.history.pushState( e.url, e.title, e.url );
					}
				}

			});
		} 
	}

	changeCurrentArticle = () => {

		this.setState({ isLoading: true }, () => {

			const getIds = (e) => {
				return (e.id === this.articlePosition[0].id)
			}

			let nextArticle = this.infinateArticles[this.state.articles.length-1]

			if(nextArticle){
				this.setState({
					articles :[ ...this.state.articles, nextArticle ]
				})
				this.articlePosition.push(
					{ 'id': nextArticle.id,
						'position': document.documentElement.offsetHeight,
						'url': nextArticle.url
					}
				)

				
				

			}

		});
	}
	  

    render(){
		const { redirect, articles} = this.state

        return (
			<div className={classes.mainWrapper}>
				
				<div className={classes.world_news_article_header}>
					<WorldNews content={globalJSON.globalAiringTimes}/>
				</div>
				<main className={classes.articles}>
					
					<Header></Header>
					{ 
						(redirect) ? <Redirect to={`${process.env.PUBLIC_URL}/`} /> :
						<IsNotDomestic>
							<Online>
								<div className={classes['heroHead__advert']}>
									<MediaQuery minWidth={classes.screenMd}>
										<DFPSlotsProvider targetingArguments={{ column: globalJSON.advertising.column }} dfpNetworkId={globalJSON.advertising.networkID} adUnit={`${globalJSON.advertising.adUnit}`}>
											<div className={`leaderboardWrapper`}>
												<div className={`leaderboard`}>
												<p className={`ads_title leaderboardTitle`}>advertisement</p>
													<div className={`leaderboardAds`}>
														<AdSlot sizes={[ [728, 90] ]} />
													</div>
												</div>
											</div>
										</DFPSlotsProvider>
									</MediaQuery>
								</div>
							</Online>
						</IsNotDomestic>
					}


					{
						(redirect) ? <Redirect to={`${process.env.PUBLIC_URL}/`} /> :
						articles.map( 
							e => <Article key={e.id} windowSize={this.props.windowSize} content={e}></Article> 
						)
					}

					<ExternalArticles content={globalJSON.external_articles} globalImages={globalImages}/>
				</main>
			</div>
        );
    }
}

export default Articles;